import toast from 'react-hot-toast';

export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        } else {
            // Fallback for non-secure contexts (e.g., HTTP)
            const textArea = document.createElement("textarea");
            textArea.value = text;

            // Ensure textarea is not visible or disrupts layout
            textArea.style.position = "fixed";
            textArea.style.left = "-9999px";
            textArea.style.top = "0";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            return successful;
        }
    } catch (err) {
        console.error('Failed to copy: ', err);
        return false;
    }
};

export const copyToClipboardWithToast = async (text: string, successMessage: string = 'Address copied to clipboard!') => {
    const success = await copyToClipboard(text);
    if (success) {
        toast.success(successMessage, {
            style: {
                background: '#333',
                color: '#fff',
            },
            iconTheme: {
                primary: '#4ade80',
                secondary: '#333',
            },
        });
    } else {
        toast.error('Failed to copy to clipboard');
    }
};
